export default "__VITE_ASSET__D$I42ntI__"